// Thin wrapper over the user axios instance, scoped to the (non
// site-uid-pathed) Threat Insights routes at
// `/api/user/v1/threat-insights/*`. Inherits the same 401-handling
// interceptor as the rest of the user surface.
//
// Phase 1 (CP) already ships:
//   GET   /threat-insights/findings   ?site_id&status&rule_id&severity&from&to&page&limit
//   PATCH /threat-insights/findings/:id   { status, notes? }
//
// `site_id` is passed as a query parameter (not in the path), because
// the CP route is scoped by the tenant's auth cookie + an optional
// per-site filter, mirroring the Phase 7 anomaly findings shape.
import userAxios from "./userAxios";

const threatInsights = {
  findings: (params) =>
    userAxios.get("/threat-insights/findings", { params }),
  updateFinding: (id, body) =>
    userAxios.patch(`/threat-insights/findings/${id}`, body),
  // TI-5 (2026-07-02): tenant-scoped Silence button.
  // Body optional: { subject_value?, duration_hours?, reason? }.
  suppressFinding: (id, body = {}) =>
    userAxios.post(`/threat-insights/findings/${id}/suppress`, body),
  // LE-364: suppress/silence note history for a finding.
  findingNotes: (id) =>
    userAxios.get(`/threat-insights/findings/${id}/notes`),
};

export default threatInsights;
